const { FIREBASE_CLOUD_FUNCTIONS_ENDPOINT } = process.env;

export default {
    FIREBASE_CLOUD_FUNCTIONS_ENDPOINT
};
